import React from "react";
import {Redirect} from "react-router-dom";
import PublicPlaylist from "../../views/PublicPlaylist/index.jsx";
import TrialLogin from "../../views/TrialLogin";
import ActivateUser from "../../views/ActivateUser";
import PublicPitchMaterial from "../../views/PublicPitchMaterial";
import PublicContentCreator from "../../views/PublicContentCreator";
import PublicReel from "../../views/PublicReel";
import PreviewContentCreator from "../../views/ContentCreators/Preview";
import PublicContentCreation from "../../views/PublicContentCreation";

export const makeRoutes = (allowed, excluded, defaultRoute) => ({
  allowed,
  excluded,
  default: defaultRoute,
});

export const route = (path = "/", component) => ({
  path,
  component,
});

export const redirectTo = to => () => <Redirect to={to} />;

export const publicRoutes = [
  route("/login/trial", TrialLogin),
  route("/public/playlists/:token", props => <PublicPlaylist {...props} token={props.match.params.token} />),
  route("/public/pitches/:pitchId/materials/:messageId", props => <PublicPitchMaterial {...props} pitchId={props.match.params.pitchId} messageId={props.match.params.messageId} />),
  route("/users/activate", ActivateUser),
  route("/public/content_creators/:contentCreatorId", PublicContentCreator),
  route("/preview/content_creators/:contentCreatorId", PreviewContentCreator),
  route("/public/content_creations/:contentCreationId", PublicContentCreation),
  route("/public/reel/:reelId", PublicReel),
  route("/bl/:contentCreatorAlias", PublicContentCreator),
];
